import { useEmbeddedEvents } from 'hooks/use-embedded-events';

export default function EmbeddedEventsController() {
  useEmbeddedEvents();

  return null;
}
